module.exports = __webpack_public_path__ + "static/media/sphtx.9b35fbc5.svg";